<template>
  <b-row>
    <b-col md="12">
      <b-carousel
        id="carousel-banner"
        :interval="3000"
        controls
        indicators
      >
        <b-carousel-slide
          v-for="(foto, index) in banner"
          :key="index"
          class="card-img-overlay"
        >
          <img
            slot="img"
            class="d-block img-fluid w-100 cursor-pointer"
            width="1599"
            height="468"
            :src="foto.picture"
            alt="image slot"
            @click="gotoinfo(foto.link, foto.tipo)"
          >
        </b-carousel-slide>
      </b-carousel>

    </b-col>
  </b-row>
</template>
<script>
import {
  BCarousel, BCarouselSlide, BRow, BCol,
} from 'bootstrap-vue'
import { ref, onMounted } from '@vue/composition-api'
import { getData } from '@core/utils/http/general'

export default {
  components: {
    BCarousel,
    BCarouselSlide,
    BRow,
    BCol,
  },
  setup() {
    const banner = ref([])
    const delivery = process.env.VUE_APP_DELIVERY_DOWNLOAD

    const cargar = () => {
      getData({ action: 6 }, 'wspagepublic')
        .then(response => {
          if (response.status !== 200) {
            banner.value = []
            return false
          }
          banner.value = response.data.data
          return true
        })
        .catch(() => {
          banner.value = []
        })
      return true
    }

    const gotoinfo = (links, tipo) => {
      if (tipo === 'externo') window.open(links, '_blank')
      else window.location.href = links
    }

    onMounted(() => {
      cargar()
    })
    return {
      banner,
      gotoinfo,
      delivery,
    }
  },
}
</script>
